import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'questions',
    label: 'Questions',
    type: types.ARRAY,
    children: [
      {
        key: 'question',
        label: 'Question',
        type: types.TEXT
      },
      {
        key: 'answer',
        label: 'Answer',
        type: types.TEXT
      }
    ]
  }
];

const defaultProps = {
  questions: [
    {
      question: 'How do I apply for a position at your Nevada manufacturing facility?',
      answer: 'Visit the Nevada section of ff.com/careers to stay up to date on available positions surrounding our manufacturing facility.'
    },
    {
      question: 'What is Faraday Future?',
      answer: 'We are a user-centric, advanced mobility company with headquarters in Silicon Valley and Southern California. Our global team leverages the talents of leading thinkers and passionate creators from the technology and automotive industries to bring premium, intuitive, and seamlessly connected electric vehicles to people worldwide.'
    },
    {
      question: 'What is the FF team like?',
      answer: 'Our U.S. team is comprised of more than 1000+ employees from diverse backgrounds spanning the automotive, technology, energy, aerospace, and design industries. Our team collaborates across department lines to strive towards a singular vision for a sustainable, globally connected future.'
    },
    {
      question: 'What’s it like to work at FF?',
      answer: 'We are a dynamic, rapidly growing company that proudly offers competitive salaries, generous benefits, and a creative, collaborative work environment. Across all levels, members of the FF team are expected to bring a degree of creativity, honesty, and intellectual rigor to their responsibilities. This is as much a career as a community, holding each other to a high standard as we work together to build a company we are proud of.'
    }
  ]
};

export default {
  title: 'Frequently Asked Questions',
  id: 'Questions',
  propsSchema,
  defaultProps
};
